// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import Container from '@/components/global-components/Container';
import Banner from '@/components/global-components/banner/Banner';
import Highlights from '@/components/global-components/highlights/Highlights';
import Programs from '@/components/global-components/programs/Programs';
import TopBanner from '@/components/global-components/top-banner/TopBanner';
import SimpleBanner from '@/components/global-components/simple-banner/SimpleBanner';

// Themes
import theme from '@/themes/index';

const SpanishOnlineBody = ({
  content: {
    topBanner,
    description,
    programHighlights,
    programsTitle,
    programs,
    banner,
    workshops,
    othersTitle,
  },
  isMobile,
  isTablet,
  isDesktop,
}) => {
  let style = {
    height: '27.75rem',
    padding: '8rem 1rem 4rem',
  };
  if (isTablet) {
    style = {
      height: '27.75rem',
      paddingTop: '4.75rem',
    };
  } else if (!isMobile) {
    style = {
      height: '33.75rem',
      paddingTop: '8.75rem',
    };
  }

  const mainPrograms = programs.filter(e => e.node.inOtherSection == false);
  const otherPrograms = programs.filter(e => e.node.inOtherSection == true);
  const faqContent = {
    title: 'Frequently Asked Questions',
    description: '',
    primaryButton: {
      title: 'Know more',
      url: '/faq',
    },
  };

  return (
    <>
      <section>
        <TopBanner
          {...topBanner}
          style={{
            ...style,
          }}
        />
      </section>
      <section className='description-section'>
        <Container>
          <RichText render={description} />
        </Container>
      </section>
      <section className='highlights-section'>
        <Container>
          <Highlights
            content={programHighlights}
            isMobile={isMobile}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <section className='programs-section'>
        <Container>
          <Programs
            content={{
              programsTitle,
              programs: mainPrograms,
            }}
            showInformationCardTitle={true}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <Banner
        content={banner}
        isDesktop={isDesktop}
        containerStyles={{
          maxWidth: '59rem',
          width: '100%',
          textAlign: 'center',
          padding: '1.5rem 0',
        }}
        contentStyles={{
          maxWidth: '43.875rem',
          padding: isMobile && '2rem 1rem',
        }}
      />
      <section className='workshops-section'>
        <Container>
          <Programs
            content={{
              programsTitle,
              programs: workshops,
            }}
            showTitle={false}
            showInformationCardTitle={true}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <hr />
      <section className='other-options-section'>
        <Container>
          <Programs
            content={{
              programsTitle: othersTitle,
              programs: otherPrograms,
            }}
            showInformationCardTitle={true}
            isDesktop={isDesktop}
          />
        </Container>
      </section>
      <section className="faq-banner-section">
        <SimpleBanner content={faqContent} />
      </section>
      <style jsx>{`
        hr {
          margin: 0 0.625rem;
        }

        section.description-section,
        section.highlights-section,
        section.programs-section,
        section.workshops-section {
          padding: 3rem 2rem;
        }

        section.description-section {
          text-align: center;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          hr {
            margin: 0 15.375rem;
          }

          section.description-section,
          section.highlights-section,
          section.programs-section,
          section.workshops-section,
          section.other-options-section {
            padding: 3rem 4.5rem;
          }
        }
      `}</style>
      <style global jsx>{`
        section.description-section p {
          text-align: center;
        }

        section.highlights-section .highlights-container h4 {
          color: ${theme.fontColors.optional5}
        }

        section.description-section p strong {
          font-family: ${theme.fontFamilies.openSansBold};
        }

        section.description-section p a {
          color: ${theme.fontColors.primary};
        }

        section.workshops-section .program-container .info-container h4,
        section.other-options-section .program-container .info-container h4 {
          margin-top: 0;
        }
      `}</style>
    </>
  );
};

export default SpanishOnlineBody;
